import { effect, Injectable, signal } from '@angular/core';
import { CountryGuideCategory, Guides, GuideType, cm } from '@sp-shared';
import { RouteNames } from '../enums/routes.enum';
import { DirectoryTile } from '../interfaces/directory-tile.interface';
import { ConfigService } from './config.service';
import { GuidesService } from './guides.service';

import { LogService } from './log.service';
@Injectable({
	providedIn: 'root'
})
export class CountryGuideService {
	guidesId = '';
	countryGuideSignal = signal<CountryGuideCategory[] | null>(null);
	constructor(
		private guidesService: GuidesService,
		private configService: ConfigService,
		private log: LogService
	) {}

	init = effect(() => {
		const guides = this.guidesService.guidesSignal();
		if (cm.isNotEmpty(guides)) {
			this.handleGuidesUpdate(guides);
		}
	});

	// countryGuideId(): string | null {
	// 	return this.countryGuideSignal().id;
	// }

	countryGuide(): CountryGuideCategory[] | null {
		return this.countryGuideSignal();
	}

	getFavoriteTiles(favorites: string[]): DirectoryTile[] {
		const countryGuides = this.countryGuideSignal().filter(country => favorites.includes(country.id));
		this.log.debug('Country Guides', countryGuides);

		let tiles: DirectoryTile[] = [];
		for (const countryGuide of countryGuides) {
			tiles.push({
				id: countryGuide.id,
				title: countryGuide?.label,
				type: GuideType.Country,
				label: '',
				url: this.configService.setupLink(RouteNames.CountryGuide, [countryGuide?.label?.toLowerCase()]),
				bookmarked: true,
				color: 'teal'
			} as DirectoryTile);
		}

		return tiles;
	}

	handleGuidesUpdate(guides: Guides): void {
		this.guidesId = guides.id;
		if (guides.countryGuides) this.countryGuideSignal.set(guides.countryGuides);
	}
}
